export default __webpack_public_path__ + "static/media/cancel.31fa6888.svg";